module.exports = "<div>\n  <restaurant-page ctrl=\"ctrl\"></restaurant-page>\n  <div ng-repeat=\"diner in ctrl.dinersInfo\" track by $index class=\"d-none\">\n      <customer-page ctrl=\"ctrl\" diner=\"diner\" index=\"$index + 1\"></customer-page>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sgoReceipt.html
// module id = 746
// module chunks = 0